module.exports = __webpack_public_path__ + "img/62-r.0ab4bbe4.png";